import { render, staticRenderFns } from "./AdvertisersProfilesMain.vue?vue&type=template&id=0340f13d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports